import { EnrichedVideoEditorEditListItemDto } from '@app/modules/video-editions/types';

/**
 * Whether the edit's latest render finished successfully (same rule as the edit card "generated" state).
 */
export function isVideoEditorEditRenderCompleted(
  edit: EnrichedVideoEditorEditListItemDto,
): boolean {
  return edit.renderJob?.status === 'COMPLETED';
}
